import { cloneDeep } from 'lodash';
import { conditionInit, defaultPageInfo } from '@/common/constants/ConstCode';

export default {
  initMemorials: (state, flag = false) => {
    state.memorials = [];
    state.condition.page = 1;
    state.condition.userNo = '';
    state.condition.limit = 10;
    state.pageInfo.totalPage = 2;
    state.condition.searchText = '';
    state.condition.searchType = '';
    state.condition.searchFlag = flag;
    state.condition.familyCode = '';
  },

  setBackgroundPreViewImage: (state, preViewImage = '') => {
    state.backgroundPreViewImage = preViewImage;
  },

  // 컨디션(페이징) 객체들이 여러개이기 때문에 하나의 함수로 처리하기위함. condtionName에 해당하는 condition명만 넣어주면 모두 공백으로 초기화
  initCondition: (state, conditionName) => {
    for (let key in state[conditionName]) {
      if (typeof state[conditionName][key] === 'boolean') state[conditionName][key] = false;
      if (typeof state[conditionName][key] === 'object') state[conditionName][key] = null;
      else state[conditionName][key] = '';
    }
    state[conditionName].page = 1;
    state[conditionName].limit = 10;
  },
  setMemorials: (state, list) => {
    state.memorials = [...state.memorials, ...list];
  },
  setChurchMemorials: (state, list) => {
    state.churchMemorials = [...state.churchMemorials, ...list];
  },
  setCondition: (state, data) => {
    Object.assign(state.condition, data);
  },
  setPageInfo: (state, info) => {
    state.pageInfo = info;
  },
  setAlivePageInfo: (state, info) => {
    Object.assign(state.alivePageInfo, info);
  },
  setChurchPageInfo: (state, info) => {
    Object.assign(state.churchPageInfo, info);
  },
  setHistoryPageInfo: (state, info) => {
    Object.assign(state.historyPageInfo, info);
  },
  setAliveCondition: (state, condition) => {
    Object.assign(state.aliveCondition, condition);
  },
  setChurchCondition: (state, condition) => {
    Object.assign(state.churchCondition, condition);
  },
  setHistoryCondition: (state, condition) => {
    Object.assign(state.historyCondition, condition);
  },
  setPage(state, page) {
    state.condition.page = page;
  },
  detailInit: (state, dataKey) => {
    for (let key in state[dataKey]) {
      state[dataKey][key] = '';
    }
  },
  setDetail: (state, data) => {
    Object.assign(state.detail, data);
  },
  setBackground: (state, data) => {
    state.backgroundList = data;
  },
  setFrame: (state, data) => {
    state.frameList = data;
  },
  setAliveDetail: (state, data) => {
    Object.assign(state.aliveDetail, data);
  },
  setChurchNo: (state, churchNo) => {
    state.churchNo = churchNo == null || churchNo === '' ? null : Number(churchNo);
  },
  setMemorialType: (state, type) => {
    console.log('setMemorialType', type);
    state.memorialType = type;
  },
  setHistoryList: (state, list) => {
    state.historyList = [...list] || [];
  },
  setAliveList: (state, list) => {
    state.aliveList = [...list] || [];
  },
  setStepOne: (state, data) => {
    Object.assign(state.register.step1, data);
  },
  initAllStep: state => {
    state.detail = {};
    state.register.step1 = {
      isInside: false,
      isOutside: false
    };
    state.register.step2 = [
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      },
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      }
    ];
    state.register.step3 = [];
    state.register.step4 = {};
  },
  setStepTwo: (state, data) => {
    state.register.step2 = cloneDeep(data);
    for (let i = 0; i < state.register.step2.length; i++) {
      state.register.step2[i].family = JSON.stringify(state.register.step2[i].family);
      // 260904 유저 "고인 사진이 등록이 안 된다" — InputFile(single-upload)은 File 하나를 emit 하는데 여기서 [0]을 읽어
      //   신규 등록 사진이 늘 빠졌다(File[0] = undefined). 수정 화면은 저장 파일 객체를 배열로 실어 오므로 둘 다 받는다.
      const raw = state.register.step2[i]?.imageFile;
      const img = Array.isArray(raw) ? raw[0] : raw;
      if (img && Object.prototype.hasOwnProperty.call(img, 'storedFileName')) {
        state.register.step2[i].deadImageInfo = img;
      } else {
        state.register.step2[i].deadImageRaw = img;
      }
    }
  },

  setStep3: (state, data) => {
    state.register.step3 = cloneDeep(data);
  },

  setCommentList: (state, comment) => {
    state.memorialCommentList = [...comment, ...state.memorialCommentList];
  },

  appendComment: (state, comment) => {
    state.memorialCommentList = [...state.memorialCommentList, comment];
  },
  setCommentPage: (state, page) => {
    state.commentCondition.page = page;
  },

  initComment: state => {
    state.memorialCommentList = [];
    state.commentCondition = { page: 1, limit: 10, memorialNo: '' };
    state.pageInfo = defaultPageInfo;
  },

  setIsMore: (state, isMore = false) => {
    state.isMore = isMore;
  },

  setAnniversaryList: (state, list) => {
    state.anniversaryList = list;
  }
};
